import type { TFunction } from "i18next";
import type { Schema } from "@/shared/components/Form/types";

export function makePaymentSettingsSchema(t: TFunction): Schema {
  return {
    secretKey: {
      type: "password",
      label: t("paymentSettings.secretKeyLabel"),
      required: true,
      xs: 12,
      sm: 6,
      fullWidth: true,
    },
    publishableKey: {
      type: "text",
      label: t("paymentSettings.publishableKeyLabel"),
      required: true,
      xs: 12,
      sm: 6,
      fullWidth: true,
    },
  };
}

export function makePaynetSettingsSchema(t: TFunction): Schema {
  return {
    merchantCode: {
      type: "text",
      label: t("paymentSettings.paynetMerchantCodeLabel"),
      required: true,
      xs: 12,
      sm: 6,
      fullWidth: true,
    },
    secretKey: {
      type: "password",
      label: t("paymentSettings.paynetNotificationSecretKeyLabel"),
      required: true,
      xs: 12,
      sm: 6,
      fullWidth: true,
    },
    user: {
      type: "text",
      label: t("paymentSettings.paynetUserLabel"),
      required: true,
      xs: 12,
      sm: 4,
      fullWidth: true,
    },
    password: {
      type: "password",
      label: t("paymentSettings.paynetPasswordLabel"),
      required: true,
      xs: 12,
      sm: 4,
      fullWidth: true,
    },
    saleArea: {
      type: "text",
      label: t("paymentSettings.paynetSaleAreaLabel"),
      xs: 12,
      sm: 4,
      fullWidth: true,
    },
  };
}

/**
 * Форма подключения CCBill. Salt отдельным password-полем и всегда пустой:
 * наружу он не отдаётся даже маской (см. схему PlatformCCBillSettings), так
 * что подставить его в initialValues нечем, и переподключение требует
 * ввести его заново.
 */
export function makeCCBillSettingsSchema(t: TFunction): Schema {
  return {
    accnum: {
      type: "text",
      label: t("paymentSettings.ccbillAccnumLabel"),
      required: true,
      xs: 12,
      sm: 6,
      fullWidth: true,
    },
    subaccount: {
      type: "text",
      label: t("paymentSettings.ccbillSubaccountLabel"),
      required: true,
      xs: 12,
      sm: 6,
      fullWidth: true,
    },
    flexFormId: {
      type: "text",
      label: t("paymentSettings.ccbillFlexFormIdLabel"),
      required: true,
      xs: 12,
      sm: 6,
      fullWidth: true,
    },
    salt: {
      type: "password",
      label: t("paymentSettings.ccbillSaltLabel"),
      required: true,
      xs: 12,
      sm: 6,
      fullWidth: true,
    },
    supportUrl: {
      type: "text",
      label: t("paymentSettings.ccbillSupportUrlLabel"),
      xs: 12,
      sm: 8,
      fullWidth: true,
    },
    sandbox: {
      type: "checkbox",
      label: t("paymentSettings.ccbillSandboxLabel"),
      xs: 12,
      sm: 4,
    },
  };
}

/**
 * Форма подключения PayPal. clientSecret отдельным password-полем: секрет
 * наружу не отдаётся целиком даже владельцу платформы (см. схему
 * PlatformPayPalSettings), только маской, поэтому в locked-состоянии поле
 * заполняется SECRET_PLACEHOLDER, а не сохранённым значением, ровно как у
 * Stripe и CCBill. clientId, наоборот, публичный: текстовое поле,
 * значение подставляется как есть.
 */
export function makePayPalSettingsSchema(t: TFunction): Schema {
  return {
    clientId: {
      type: "text",
      label: t("paymentSettings.paypalClientIdLabel"),
      required: true,
      xs: 12,
      sm: 6,
      fullWidth: true,
    },
    clientSecret: {
      type: "password",
      label: t("paymentSettings.paypalClientSecretLabel"),
      required: true,
      xs: 12,
      sm: 6,
      fullWidth: true,
    },
    sandbox: {
      type: "checkbox",
      label: t("paymentSettings.paypalSandboxLabel"),
      helperText: t("paymentSettings.paypalSandboxHelperText"),
      xs: 12,
    },
  };
}
